// Enumerations
import { ProofIncomeMethodsEnumeration } from 'containers/proof-income/enumerations/proof-income-methods.enumeration';
// Translations
import {
  PROOF_INCOME_LANDING_MODAL_FEATURE_01_OPENBANKING,
  PROOF_INCOME_LANDING_MODAL_FEATURE_01_TGSS,
  PROOF_INCOME_LANDING_MODAL_FEATURE_02_OPENBANKING,
  PROOF_INCOME_LANDING_MODAL_FEATURE_02_TGSS,
  PROOF_INCOME_LANDING_MODAL_FEATURE_03_OPENBANKING,
  PROOF_INCOME_LANDING_MODAL_FEATURE_03_TGSS,
} from '../translations/proof-income-landing.translations';

const PROOF_INCOME_LANDING_MODAL_CONFIGURATION = {
  features: {
    [`${ProofIncomeMethodsEnumeration.OPENBANKING}`]: [
      {
        description: PROOF_INCOME_LANDING_MODAL_FEATURE_01_OPENBANKING,
        icon: 'icon_symbols_checkmark',
      },
      {
        description: PROOF_INCOME_LANDING_MODAL_FEATURE_02_OPENBANKING,
        icon: 'icon_documents_document',
      },
      {
        description: PROOF_INCOME_LANDING_MODAL_FEATURE_03_OPENBANKING,
        icon: 'icon_security_close',
      },
    ],
    [`${ProofIncomeMethodsEnumeration.TGSS}`]: [
      {
        description: PROOF_INCOME_LANDING_MODAL_FEATURE_01_TGSS,
        icon: 'icon_symbols_checkmark',
      },
      {
        description: PROOF_INCOME_LANDING_MODAL_FEATURE_02_TGSS,
        icon: 'icon_documents_document',
      },
      {
        description: PROOF_INCOME_LANDING_MODAL_FEATURE_03_TGSS,
        icon: 'icon_objects_hourglass-start',
      },
    ],
  },
};

export { PROOF_INCOME_LANDING_MODAL_CONFIGURATION };
